import React from 'react';

import { TextField, withValidatedInputs } from '../../../../components/forms';
import {SliderPicker} from 'react-color';
import Button from 'material-ui/Button';
import {Delete} from 'material-ui-icons';

import Dialog, {
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from 'material-ui/Dialog';

import tsl from './../../../tsl';

import Immutable from 'immutable';

export class CalendarForm extends React.Component {
	state = {
	}

	propagateChanges = (calendar) => {
		this.props.onChange(calendar);
	}

	handleChange = (e) => {
		let calendar = this.props.calendar;
		calendar[e.target.name] = e.target.value;
		this.propagateChanges(calendar);
	}

    handleColorChange = (color) => {
        let calendar = this.props.calendar;
        calendar.color_hex = color.hex;
        this.propagateChanges(calendar);
    };

	handleSave = () => {
		if (this.props.trySubmit()) {
			this.props.onSave();
		}
	};

	handleClose = () => {
		this.props.resetFormErrors();

		this.props.onClose();
	};

	render() {
		const {
			calendar
		} = this.props;
		
		
		return (
			<Dialog onClose={this.handleClose} open={calendar != null} >
				<DialogTitle>{tsl('calendar.calendarform.header')}</DialogTitle>
				<DialogContent>

             <TextField
							  formActions={this.props.formActions}
								required
                fullWidth
                label={tsl('calendar.calendarform.name')}
                name="name"
                value={calendar.name || ''}
                onChange={this.handleChange}
            />
            <br /><br />
            <SliderPicker 
                color={this.props.calendar.color_hex}
                onChange={this.handleColorChange}
                className="w-100"
            />

				</DialogContent>
				<DialogActions>
					{!calendar.id ? '' :
						<Button onClick={this.props.onDelete} style={{color: 'red'}}>
							<Delete /> {tsl('calendar.calendarform.delete')}
						</Button>
					}
					<Button onClick={this.handleClose}>
						{tsl('calendar.calendarform.close')}
					</Button>
					<Button onClick={this.handleSave} color="primary">
						{tsl('calendar.calendarform.save')}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

}

export default withValidatedInputs(CalendarForm);


// WEBPACK FOOTER //
// ./app/used/calendar/routes/CalendarForm.js